import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";

export interface IGraphPayload {
  dc: string[];
  storeNumber: string[];
  subCategoryOnAd: string;
  acrossSubCategory: string;
}

export interface IFilterPayload {
  dc: string[];
  storeNumber: string[];
}

export const cannibalizationAPI = createApi({
  reducerPath: "cannibalizationAPI",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    // Existing Graph Data mutation
    getGraphData: builder.mutation({
      query: (payload: IGraphPayload) => ({
        url: "/barChatCannibalization",
        method: "POST",
        data: payload,
      }),
    }),

    // New Filter Data mutation
    getFilterData: builder.mutation({
      query: (payload: IFilterPayload) => ({
        url: "/barChartFiltersCannibalization", // New API endpoint
        method: "POST",
        data: payload,
      }),
    }),
  }),
});

// Export the hooks
export const {
  useGetGraphDataMutation, // Existing hook
  useGetFilterDataMutation, // New hook for the filter
} = cannibalizationAPI;
